/** @jsx jsx */
import React, { ReactElement } from 'react';
import { jsx } from '@emotion/core';

import { Box, Container } from '@material-ui/core';

import CompletionIcon from 'features/CompletionIcon';
import ApplicationProgress from 'features/ApplicationProgress';

import PageContainer from 'components/PageContainer';
import styles from './styles';
import ActionButtonContainer from 'components/ActionButtonsContainer';
import { contentContainer } from 'features/Theme/mixins';

interface PropTypes {
  headerTitle: string | ReactElement;
  /**
   * If a string, the string will be wrapped in a paragraph.
   * If a ReactElement, it will be inserted as is.
   */
  message: string | ReactElement;

  /**
   * If this signify the end of the application
   * This will cause the page to have a completed ApplicationProgress bar.
   */
  completed?: boolean;
}

/**
 * A page for displaying a simple message and a number of action buttons.
 *
 * The actions button are passed as children.
 */
const SimpleMessagePage: React.FC<PropTypes> = ({
  headerTitle,
  message,
  children,
  completed,
}) => {
  const messageComponent =
    typeof message !== 'string' ? (
      <div css={styles.body}>{message}</div>
    ) : (
      <p
        css={styles.body}
        dangerouslySetInnerHTML={{
          __html: message,
        }}
      />
    );
  return (
    <Box css={contentContainer}>
      {completed && (
        <React.Fragment>
          <CompletionIcon />
          <ApplicationProgress completed />
        </React.Fragment>
      )}

      <PageContainer>
        <h1 css={styles.headerTitle}>{headerTitle}</h1>

        <Container maxWidth="sm">
          <Box my={3}>{messageComponent}</Box>
          {children && (
            <ActionButtonContainer>{children}</ActionButtonContainer>
          )}
        </Container>
      </PageContainer>
    </Box>
  );
};

export default SimpleMessagePage;
